import React from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu } from 'reactstrap';

/**
 * TopnavNotifications
 *
 * A bell that opens a notifications panel. There is no persisted notification
 * history feed yet — live events surface through the toast system
 * (ToastNotifications) and the Action History panel — so this shows an honest
 * empty state rather than the old hardcoded fixtures with a permanent "3" badge
 * that never reflected anything real. When a real feed exists, drive `count`
 * and the list from it; the badge only renders when count > 0.
 */
const TopnavNotifications = ({ count = 0, items = [] }) => {
  return (
    <div className="position-relative d-inline-block">
      <UncontrolledDropdown className="dropdown-menu-right">
        <DropdownToggle
          className="header-icon notificationButton"
          color="empty"
          aria-label="Notifications"
        >
          <i className="simple-icon-bell" data-tooltip="Notifications" />
          {count > 0 && <span className="count">{count > 9 ? '9+' : count}</span>}
        </DropdownToggle>
        <DropdownMenu
          className="position-absolute mt-3 scroll"
          right
          id="notificationDropdown"
        >
          {items.length === 0 ? (
            <div className="notifications-empty">
              <i className="simple-icon-bell" aria-hidden="true" />
              <p className="notifications-empty-title">You're all caught up</p>
              <p className="notifications-empty-sub">Alerts appear here as they happen.</p>
            </div>
          ) : (
            items.map((n, index) => (
              <div key={n.id || index} className="d-flex flex-row mb-3 pb-3 border-bottom">
                <div className="pl-3 pr-2">
                  <p className="font-weight-medium mb-1">{n.title}</p>
                  <p className="text-muted mb-0 text-small">{n.date}</p>
                </div>
              </div>
            ))
          )}
        </DropdownMenu>
      </UncontrolledDropdown>
    </div>
  );
};

export default TopnavNotifications;
